// The grade bands ("bouwen") of a school: the single definition of which grades belong to which band.
export const GRADE_BANDS = [
  { key: "lower_grades", defaultLabel: "Lower grades", minGrade: 1, maxGrade: 6 },
  { key: "middle_grades", defaultLabel: "Middle grades", minGrade: 7, maxGrade: 8 },
  { key: "upper_grades", defaultLabel: "Upper grades", minGrade: 9, maxGrade: 12 },
] as const;

export type GradeBand = (typeof GRADE_BANDS)[number];

export const gradeBandGrades = ({ minGrade, maxGrade }: GradeBand): number[] =>
  Array.from({ length: maxGrade - minGrade + 1 }, (_, i) => minGrade + i);

export const isGradeInBand = (band: GradeBand, grade: unknown): boolean => {
  const value = Number(grade);
  return grade != null && grade !== "" && value >= band.minGrade && value <= band.maxGrade;
};
